export default __webpack_public_path__ + "static/media/ecoclyb.2bae47da.png";